import { render, staticRenderFns } from "./RewardsSideMenuContents.vue?vue&type=template&id=af7eb8c6"
import script from "./RewardsSideMenuContents.vue?vue&type=script&lang=ts&setup=true"
export * from "./RewardsSideMenuContents.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RewardsSideMenuContents.vue?vue&type=style&index=0&id=af7eb8c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports